export const formatMoney = (cents, currency = "aud") => {
  if (cents == null) return "";
  try {
    return new Intl.NumberFormat("en-AU", {
      style: "currency",
      currency: (currency || "aud").toUpperCase(),
      minimumFractionDigits: Number.isInteger(cents / 100) ? 0 : 2,
    }).format(cents / 100);
  } catch {
    return `$${(cents / 100).toFixed(2)}`;
  }
};

export const intervalLabel = (interval) => (interval === "year" ? "year" : "month");
